export const USER_LOGOUT = 'USER_LOGOUT';

export const commonConst = {
  GET_ERROR: 'GET_ERROR',
  RESET_STATE: 'RESET_STATE',
  RESPONSE_PENDING: 'RESPONSE_PENDING',
};

//login
export const loginConst = {
  GET_LOGIN_REQUEST: 'GET_LOGIN_REQUEST',
  GET_LOGIN_REQUEST_SUCCESS: 'GET_LOGIN_REQUEST_SUCCESS',

  GET_LOGIN_INFO: 'GET_LOGIN_INFO',
  GET_LOGIN_INFO_SUCCESS: 'GET_LOGIN_INFO_SUCCESS',

  GET_MENUS: 'GET_MENUS',
  GET_MENUS_SUCCESS: 'GET_MENUS_SUCCESS',

  GET_LOGOUT: 'GET_LOGOUT',
  GET_LOGOUT_SUCCESS: 'GET_LOGOUT_SUCCESS',

  LOGIN_PENDING: 'LOGIN_PENDING',

  LOGIN_UPDATE_PASS: 'LOGIN_UPDATE_PASS',
  LOGIN_UPDATE_PASS_SUCCESS: 'LOGIN_UPDATE_PASS_SUCCESS',

  GET_MENUS_TREE: 'GET_MENUS_TREE',
  GET_MENUS_TREE_SUCCESS: 'GET_MENUS_TREE_SUCCESS',

  LOGIN_RESET_STATE: 'LOGIN_RESET_STATE',
  LOGIN_ERROR: 'LOGIN_ERROR',
};

//contract-query
export const contractQueryConstant = {
  GET_GENERAL_INFO: 'GET_GENERAL_INFO',
  GET_GENERAL_INFO_SUCCESS: 'GET_GENERAL_INFO_SUCCESS',

  EXPORT_TO_EXCEL_TRANSACTION: 'EXPORT_TO_EXCEL_TRANSACTION',
  EXPORT_TO_EXCEL_TRANSACTION_SUCCESS: 'EXPORT_TO_EXCEL_TRANSACTION_SUCCESS',

  EXPORT_FEE_TO_EXCEL: 'EXPORT_FEE_TO_EXCEL',
  EXPORT_FEE_TO_EXCEL_SUCCESS: 'EXPORT_FEE_TO_EXCEL_SUCCESS',

  GET_CUSTOMER_INFO: 'GET_CUSTOMER_INFO',
  GET_CUSTOMER_INFO_SUCCESS: 'GET_CUSTOMER_INFO_SUCCESS',

  GET_ACC_VALUE_SEARCH_PAV: 'GET_ACC_VALUE_SEARCH_PAV',
  GET_ACC_VALUE_SEARCH_PAV_SUCCESS: 'GET_ACC_VALUE_SEARCH_PAV_SUCCESS',

  GET_ACC_VALUE_SEARCH_LOAN: 'GET_ACC_VALUE_SEARCH_LOAN',
  GET_ACC_VALUE_SEARCH_LOAN_SUCCESS: 'GET_ACC_VALUE_SEARCH_LOAN_SUCCESS',

  GET_ACC_VALUE_FUND_TYPE_LIST: 'GET_ACC_VALUE_FUND_TYPE_LIST',
  GET_ACC_VALUE_FUND_TYPE_LIST_SUCCESS: 'GET_ACC_VALUE_FUND_TYPE_LIST_SUCCESS',

  GET_ACC_FUND_DETAILS: 'GET_ACC_FUND_DETAILS',
  GET_ACC_FUND_DETAILS_SUCCESS: 'GET_ACC_FUND_DETAILS_SUCCESS',

  GET_PAY_PROCESS_PREMIUM_TRANS: 'GET_PAY_PROCESS_PREMIUM_TRANS',
  GET_PAY_PROCESS_PREMIUM_TRANS_SUCCESS: 'GET_PAY_PROCESS_PREMIUM_TRANS_SUCCESS',

  GET_PAY_PROCESS_PREMIUM_TRANS_INFO: 'GET_PAY_PROCESS_PREMIUM_TRANS_INFO',
  GET_PAY_PROCESS_PREMIUM_TRANS_INFO_SUCCESS: 'GET_PAY_PROCESS_PREMIUM_TRANS_INFO_SUCCESS',

  GET_FEES_CHANRGES_TRANSS: 'GET_FEES_CHANRGES_TRANSS',
  GET_FEES_CHANRGES_TRANSS_SUCCESS: 'GET_FEES_CHANRGES_TRANSS_SUCCESS',

  GET_BENEFIT_RESOLVING: 'GET_BENEFIT_RESOLVING',
  GET_BENEFIT_RESOLVING_SUCCESS: 'GET_BENEFIT_RESOLVING_SUCCESS',

  GET_RESOLVE_RIGHT_PAID: 'GET_RESOLVE_RIGHT_PAID',
  GET_RESOLVE_RIGHT_PAID_SUCCESS: 'GET_RESOLVE_RIGHT_PAID_SUCCESS',

  GET_GENERAL_ACC_INFO: 'GET_GENERAL_ACC_INFO',
  GET_GENERAL_ACC_INFO_SUCCESS: 'GET_GENERAL_ACC_INFO_SUCCESS',

  GET_CS_TYPES: 'GET_CS_TYPES',
  GET_CS_TYPES_SUCCESS: 'GET_CS_TYPES_SUCCESS',

  PERSONAL_PRODUCT_PENDING: 'PERSONAL_PRODUCT_PENDING',
  PERSONAL_PRODUCT_RESET_STATE: 'PERSONAL_PRODUCT_RESET_STATE',
  PERSONAL_PRODUCT_ERROR: 'PERSONAL_PRODUCT_ERROR',
};

//group-product
export const groupProductConst = {
  GET_GROUP_ACC_LIST: 'GET_GROUP_ACC_LIST',
  GET_GROUP_ACC_LIST_SUCCESS: 'GET_GROUP_ACC_LIST_SUCCESS',

  GET_ACC_NUMBER: 'GET_ACC_NUMBER',
  GET_ACC_NUMBER_SUCCESS: 'GET_ACC_NUMBER_SUCCESS',

  GET_GROUP_INFO: 'GET_GROUP_INFO',
  GET_GROUP_INFO_SUCCESS: 'GET_GROUP_INFO_SUCCESS',

  GET_MEMBER_CONTRACT: 'GET_MEMBER_CONTRACT',
  GET_MEMBER_CONTRACT_SUCCESS: 'GET_MEMBER_CONTRACT_SUCCESS',

  GET_MEMBER_CONTRACT_ACCOUNT_INFO: 'GET_MEMBER_CONTRACT_ACCOUNT_INFO',
  GET_MEMBER_CONTRACT_ACCOUNT_INFO_SUCCESS: 'GET_MEMBER_CONTRACT_ACCOUNT_INFO_SUCCESS',

  GET_MEMBER_CONTRACT_INSURANCE_INFO: 'GET_MEMBER_CONTRACT_INSURANCE_INFO',
  GET_MEMBER_CONTRACT_INSURANCE_INFO_SUCCESS: 'GET_MEMBER_CONTRACT_INSURANCE_INFO_SUCCESS',

  GET_GROUP_PREM_TRANS: 'GET_GROUP_PREM_TRANS',
  GET_GROUP_PREM_TRANS_SUCCESS: 'GET_GROUP_PREM_TRANS_SUCCESS',

  GET_FEES_CHARGES_TRANS: 'GET_FEES_CHARGES_TRANS',
  GET_FEES_CHARGES_TRANS_SUCCESS: 'GET_FEES_CHARGES_TRANS_SUCCESS',

  GET_GROUP_CLAIM_PAYMENT: 'GET_GROUP_CLAIM_PAYMENT',
  GET_GROUP_CLAIM_PAYMENT_SUCCESS: 'GET_GROUP_CLAIM_PAYMENT_SUCCESS',

  GET_GROUP_PAVS: 'GET_GROUP_PAVS',
  GET_GROUP_PAVS_SUCCESS: 'GET_GROUP_PAVS_SUCCESS',

  GET_GROUP_LOANS: 'GET_GROUP_LOANS',
  GET_GROUP_LOANS_SUCCESS: 'GET_GROUP_LOANS_SUCCESS',

  GET_BENIFIT: 'GET_BENIFIT',
  GET_BENIFIT_SUCCESS: 'GET_BENIFIT_SUCCESS',

  GET_CLAIM_INFO: 'GET_CLAIM_INFO',
  GET_CLAIM_INFO_SUCCESS: 'GET_CLAIM_INFO_SUCCESS',

  GROUP_NUMBER: 'GROUP_NUMBER',
  GROUP_NUMBER_SUCCESS: 'GROUP_NUMBER_SUCCESS',

  GET_GENERAL_ACC_INFO: 'GET_GENERAL_ACC_INFO',
  GET_GENERAL_ACC_INFO_SUCCESS: 'GET_GENERAL_ACC_INFO_SUCCESS',

  EXPORT_FEE_TO_EXCEL: 'EXPORT_FEE_TO_EXCEL',
  EXPORT_FEE_TO_EXCEL_SUCCESS: 'EXPORT_FEE_TO_EXCEL_SUCCESS',

  EXPORT_TO_EXCEL_TRANSACTION: 'EXPORT_TO_EXCEL_TRANSACTION',
  EXPORT_TO_EXCEL_TRANSACTION_SUCCESS: 'EXPORT_TO_EXCEL_TRANSACTION_SUCCESS',

  GROUP_PRODUCT_PENDING: 'GROUP_PRODUCT_PENDING',
  GROUP_PRODUCT_RESET_STATE: 'GROUP_PRODUCT_RESET_STATE',
  GROUP_PRODUCT_ERROR: 'GROUP_PRODUCT_ERROR',
};
//category-menu
export const catMenuConst = {
  GET_MENU_LIST: 'GET_MENU_LIST',
  GET_MENU_LIST_SUCCESS: 'GET_MENU_LIST_SUCCESS',

  GET_MENU_LIST_BY_ROLE: 'GET_MENU_LIST_BY_ROLE',
  GET_MENU_LIST_BY_ROLE_SUCCESS: 'GET_MENU_LIST_BY_ROLE_SUCCESS',

  GET_MENU_CHILDS: 'GET_MENU_CHILDS',
  GET_MENU_CHILDS_SUCCESS: 'GET_MENU_CHILDS_SUCCESS',

  GET_MENU_CURRENT_PAGE: 'GET_MENU_CURRENT_PAGE',
  GET_MENU_CURRENT_PAGE_SUCCESS: 'GET_MENU_CURRENT_PAGE_SUCCESS',

  GET_MENU_TREE_PUBLIC: 'GET_MENU_TREE_PUBLIC',
  GET_MENU_TREE_PUBLIC_SUCCESS: 'GET_MENU_TREE_PUBLIC_SUCCESS',

  ADD_EPOS_MENU: 'ADD_EPOS_MENU',
  ADD_EPOS_MENU_SUCCESS: 'ADD_EPOS_MENU_SUCCESS',

  UPDATE_EPOS_MENU: 'UPDATE_EPOS_MENU',
  UPDATE_EPOS_MENU_SUCCESS: 'UPDATE_EPOS_MENU_SUCCESS',

  DELETE_EPOS_MENU: 'DELETE_EPOS_MENU',
  DELETE_EPOS_MENU_SUCCESS: 'DELETE_EPOS_MENU_SUCCESS',

  GET_ALL_MENU_BY_ROLE: 'GET_ALL_MENU_BY_ROLE',

  MENU_PENDING: 'MENU_PENDING',
  MENU_RESET_STATE: 'MENU_RESET_STATE',
  MENU_ERROR: 'MENU_ERROR',
};

//category param system
export const catParamSystemConst = {
  GET_PARAM_SYSTEM_LIST: 'GET_PARAM_SYSTEM_LIST',
  GET_PARAM_SYSTEM_LIST_SUCCESS: 'GET_PARAM_SYSTEM_LIST_SUCCESS',

  INSERT_PARAM_SYSTEM: 'INSERT_PARAM_SYSTEM',
  INSERT_PARAM_SYSTEM_SUCCESS: 'INSERT_PARAM_SYSTEM_SUCCESS',

  UPDATE_PARAM_SYSTEM: 'UPDATE_PARAM_SYSTEM',
  UPDATE_PARAM_SYSTEM_SUCCESS: 'UPDATE_PARAM_SYSTEM_SUCCESS',

  DELETE_PARAM_SYSTEM: 'DELETE_PARAM_SYSTEM',
  DELETE_PARAM_SYSTEM_SUCCESS: 'DELETE_PARAM_SYSTEM_SUCCESS',

  GET_PARAM_CURRENT_PAGE: 'GET_PARAM_CURRENT_PAGE',
  GET_PARAM_CURRENT_PAGE_SUCCESS: 'GET_PARAM_CURRENT_PAGE_SUCCESS',

  PARAM_SYSTEM_PENDING: 'PARAM_SYSTEM_PENDING',
  PARAM_SYSTEM_RESET_STATE: 'PARAM_SYSTEM_RESET_STATE',
  PARAM_SYSTEM_ERROR: 'PARAM_SYSTEM_ERROR',
};

//manage account info
export const manageAccountInfoConst = {
  GET_ACCOUNT_INFO_LIST: 'GET_ACCOUNT_INFO_LIST',
  GET_ACCOUNT_INFO_LIST_SUCCESS: 'GET_ACCOUNT_INFO_LIST_SUCCESS',

  MANAGE_ACCOUNT_INSERT_USER_RIGHT: 'MANAGE_ACCOUNT_INSERT_USER_RIGHT',
  MANAGE_ACCOUNT_INSERT_USER_RIGHT_SUCCESS: 'MANAGE_ACCOUNT_INSERT_USER_RIGHT_SUCCESS',

  MANAGE_ACCOUNT_CHANGE_USER_INFO: 'MANAGE_ACCOUNT_CHANGE_USER_INFO',
  MANAGE_ACCOUNT_CHANGE_USER_INFO_SUCCESS: 'MANAGE_ACCOUNT_CHANGE_USER_INFO_SUCCESS',

  MANAGE_ACCOUNT_REOPEN_USER: 'MANAGE_ACCOUNT_REOPEN_USER',
  MANAGE_ACCOUNT_REOPEN_USER_SUCCESS: 'MANAGE_ACCOUNT_REOPEN_USER_SUCCESS',

  MANAGE_ACCOUNT_CLOSE_USER: 'MANAGE_ACCOUNT_CLOSE_USER',
  MANAGE_ACCOUNT_CLOSE_USER_SUCCESS: 'MANAGE_ACCOUNT_CLOSE_USER_SUCCESS',

  GET_ACCOUNT_INFO_CURRENT_PAGE: 'GET_ACCOUNT_INFO_CURRENT_PAGE',
  GET_ACCOUNT_INFO_CURRENT_PAGE_SUCCESS: 'GET_ACCOUNT_INFO_CURRENT_PAGE_SUCCESS',

  MANAGE_ACCOUNT_USER_RIGHT: 'MANAGE_ACCOUNT_USER_RIGHT',
  MANAGE_ACCOUNT_USER_RIGHT_SUCCESS: 'MANAGE_ACCOUNT_USER_RIGHT_SUCCESS',

  MANAGE_ACCOUNT_RESET_PASS_WORD: 'MANAGE_ACCOUNT_RESET_PASS_WORD',
  MANAGE_ACCOUNT_RESET_PASS_WORD_SUCCESS: 'MANAGE_ACCOUNT_RESET_PASS_WORD_SUCCESS',

  MANAGE_ACCOUNT_INFO_PENDING: 'MANAGE_ACCOUNT_INFO_PENDING',
  MANAGE_ACCOUNT_INFO_RESET_STATE: 'MANAGE_ACCOUNT_INFO_RESET_STATE',
  MANAGE_ACCOUNT_INFO_ERROR: 'MANAGE_ACCOUNT_INFO_ERROR',
};

//manage account info
export const manageJobConst = {
  GET_JOB_LIST: 'GET_JOB_LIST',
  GET_JOB_LIST_SUCCESS: 'GET_JOB_LIST_SUCCESS',

  MANAGE_JOB_EXPORT_LOG: 'MANAGE_JOB_EXPORT_LOG',
  MANAGE_JOB_EXPORT_LOG_SUCCESS: 'MANAGE_JOB_EXPORT_LOG_SUCCESS',

  GET_ACCOUNT_INFO_CURRENT_PAGE: 'GET_ACCOUNT_INFO_CURRENT_PAGE',
  GET_ACCOUNT_INFO_CURRENT_PAGE_SUCCESS: 'GET_ACCOUNT_INFO_CURRENT_PAGE_SUCCESS',

  MANAGE_ACCOUNT_USER_RIGHT: 'MANAGE_ACCOUNT_USER_RIGHT',
  MANAGE_ACCOUNT_USER_RIGHT_SUCCESS: 'MANAGE_ACCOUNT_USER_RIGHT_SUCCESS',

  MANAGE_JOB_START_OR_RESUM_JOB: 'MANAGE_JOB_START_OR_RESUM_JOB',
  MANAGE_JOB_START_OR_RESUM_JOB_SUCCESS: 'MANAGE_JOB_START_OR_RESUM_JOB_SUCCESS',

  MANAGE_JOB_PAUSE_JOB: 'MANAGE_JOB_PAUSE_JOB',
  MANAGE_JOB_PAUSE_JOB_SUCCESS: 'MANAGE_JOB_PAUSE_JOB_SUCCESS',

  MANAGE_JOB_DELETE_JOB: 'MANAGE_JOB_DELETE_JOB',
  MANAGE_JOB_DELETE_JOB_SUCCESS: 'MANAGE_JOB_DELETE_JOB_SUCCESS',

  MANAGE_JOB_REOPEN_USER: 'MANAGE_JOB_REOPEN_USER',
  MANAGE_JOB_REOPEN_USER_SUCCESS: 'MANAGE_JOB_REOPEN_USER_SUCCESS',

  MANAGE_JOB_CHANGE_JOB: 'MANAGE_JOB_CHANGE_JOB',
  MANAGE_JOB_CHANGE_JOB_SUCCESS: 'MANAGE_JOB_CHANGE_JOB_SUCCESS',

  MANAGE_JOB_RUN_JOB: 'MANAGE_JOB_RUN_JOB',
  MANAGE_JOB_RUN_JOB_SUCCESS: 'MANAGE_JOB_RUN_JOB_SUCCESS',

  MANAGE_ACCOUNT_INFO_PENDING: 'MANAGE_ACCOUNT_INFO_PENDING',
  MANAGE_ACCOUNT_INFO_RESET_STATE: 'MANAGE_ACCOUNT_INFO_RESET_STATE',
  MANAGE_ACCOUNT_INFO_ERROR: 'MANAGE_ACCOUNT_INFO_ERROR',

  GET_LIST_MANUAL_JOB: 'GET_LIST_MANUAL_JOB',
  GET_LIST_JOB_BY_GROUP: 'GET_LIST_JOB_BY_GROUP',
  ADD_MANUAL_JOB: 'ADD_MANUAL_JOB',
};

//premium-payment
export const prePaymentConst = {
  GET_PAY_INVOICE: 'GET_PAY_INVOICE',
  GET_PAY_INVOICE_SUCCESS: 'GET_PAY_INVOICE_SUCCESS',

  GET_PAY_RESULT_MOMO: 'GET_PAY_RESULT_MOMO',
  GET_PAY_RESULT_MOMO_SUCCESS: 'GET_PAY_RESULT_MOMO_SUCCESS',

  GET_PRIMUM_RESULT: 'GET_PRIMUM_RESULT',
  GET_PRIMUM_RESULT_SUCCESS: 'GET_PRIMUM_RESULT_SUCCESS',

  GET_PAY_VIA_MOMO: 'GET_PAY_VIA_MOMO',
  GET_PAY_VIA_MOMO_SUCCESS: 'GET_PAY_VIA_MOMO_SUCCESS',

  GET_PAY_VIA_NAPAS: 'GET_PAY_VIA_NAPAS',
  GET_PAY_VIA_NAPAS_SUCCESS: 'GET_PAY_VIA_NAPAS_SUCCESS',

  GET_PAY_VIA_BAOVIETBANK: 'GET_PAY_VIA_BAOVIETBANK',
  GET_PAY_VIA_BAOVIETBANK_SUCCESS: 'GET_PAY_VIA_BAOVIETBANK_SUCCESS',

  GET_PAY_RESULT: 'GET_PAY_RESULT',
  GET_PAY_RESULT_SUCCESS: 'GET_PAY_RESULT_SUCCESS',

  GET_PAY_RESULT_ECOM: 'GET_PAY_RESULT_ECOM',
  GET_PAY_RESULT_ECOM_SUCCESS: 'GET_PAY_RESULT_ECOM_SUCCESS',

  LOG_RESPONSE_VIA_NAPAS: 'LOG_RESPONSE_VIA_NAPAS',
  LOG_RESPONSE_VIA_NAPAS_SUCCESS: 'LOG_RESPONSE_VIA_NAPAS_SUCCESS',

  PAY_PENDING: 'PAY_PENDING',
  PAY_RESET_STATE: 'PAY_RESET_STATE',
  PAY_RESET_STATE_SUCCESS: 'PAY_RESET_STATE_SUCCESS',
  PAY_ERROR: 'PAY_ERROR',
};

//user-role
export const userRoleConst = {
  GET_USER_ROLE: 'GET_USER_ROLE',
  GET_USER_ROLE_SUCCESS: 'GET_USER_ROLE_SUCCESS',

  GET_ROLE_BY_USER: 'GET_ROLE_BY_USER',
  GET_ROLE_BY_USER_SUCCESS: 'GET_ROLE_BY_USER_SUCCESS',

  ADD_ROLE_TO_USER: 'ADD_ROLE_TO_USER',
  ADD_ROLE_TO_USER_SUCCESS: 'ADD_ROLE_TO_USER_SUCCESS',

  DELETE_ROLE_BY_USER: 'DELETE_ROLE_BY_USER',
  DELETE_ROLE_BY_USER_SUCCESS: 'DELETE_ROLE_BY_USER_SUCCESS',

  GET_ROLE_LIST: 'GET_ROLE_LIST',
  GET_ROLE_LIST_SUCCESS: 'GET_ROLE_LIST_SUCCESS',

  INSERT_OTHER_ROLE_TO_USE: 'INSERT_OTHER_ROLE_TO_USE',

  USER_ROLE_PENDING: 'USER_ROLE_PENDING',
  USER_ROLE_RESET_STATE: 'USER_ROLE_RESET_STATE',
  USER_ROLE_ERROR: 'USER_ROLE_ERROR',
};

//user-role
export const roleMenuConst = {
  GET_ROLE_LIST: 'GET_ROLE_LIST',
  GET_ROLE_LIST_SUCCESS: 'GET_ROLE_LIST_SUCCESS',

  GET_MENU_BY_ROLE: 'GET_MENU_BY_ROLE',
  GET_MENU_BY_ROLE_SUCCESS: 'GET_MENU_BY_ROLE_SUCCESS',

  GET_MENU_LIST_ROLE_MENU: 'GET_MENU_LIST_ROLE_MENU',
  GET_MENU_LIST_ROLE_MENU_SUCCESS: 'GET_MENU_LIST_ROLE_MENU_SUCCESS',

  GET_MENU_LIST_CURRENT_PAGE: 'GET_MENU_LIST_CURRENT_PAGE',
  GET_MENU_LIST_CURRENT_PAGE_SUCCESS: 'GET_MENU_LIST_CURRENT_PAGE_SUCCESS',

  CHECK_EXIST_ROLE_MENU: 'CHECK_EXIST_ROLE_MENU',
  CHECK_EXIST_ROLE_MENU_SUCCESS: 'CHECK_EXIST_ROLE_MENU_SUCCESS',

  DELETE_EPOS_ROLE_MENU: 'DELETE_EPOS_ROLE_MENU',
  DELETE_EPOS_ROLE_MENU_SUCCESS: 'DELETE_EPOS_ROLE_MENU_SUCCESS',

  INSERT_MENU_ROLE: 'INSERT_MENU_ROLE',
  INSERT_MENU_ROLE_SUCCESS: 'INSERT_MENU_ROLE_SUCCESS',

  UPDATE_ROLE: 'UPDATE_ROLE',
  UPDATE_ROLE_SUCCESS: 'UPDATE_ROLE_SUCCESS',

  ADD_ROLE: 'ADD_ROLE',
  ADD_ROLE_SUCCESS: 'ADD_ROLE_SUCCESS',

  DELETE_ROLE: 'DELETE_ROLE',
  DELETE_ROLE_SUCCESS: 'DELETE_ROLE_SUCCESS',

  ROLE_MENU_PENDING: 'ROLE_MENU_PENDING',
  ROLE_MENU_RESET_STATE: 'ROLE_MENU_RESET_STATE',
  ROLE_MENU_ERROR: 'ROLE_MENU_ERROR',
};

//account-info
export const accountInfoContractConst = {
  GET_ACCOUNT_INFO: 'GET_ACCOUNT_INFO',
  GET_ACCOUNT_INFO_SUCCESS: 'GET_ACCOUNT_INFO_SUCCESS',

  GET_ACCOUNT_INFO_CONTRACT: 'GET_ACCOUNT_INFO_CONTRACT',
  GET_ACCOUNT_INFO_CONTRACT_SUCCESS: 'GET_ACCOUNT_INFO_CONTRACT_SUCCESS',

  ACCOUNT_INFO_PENDING: 'ACCOUNT_INFO_PENDING',
  ACCOUNT_INFO_RESET_STATE: 'ACCOUNT_INFO_RESET_STATE',
  ACCOUNT_INFO_ERROR: 'ACCOUNT_INFO_ERROR',
  ACCOUNT_INFO_PENDING2: 'ACCOUNT_INFO_PENDING2',
  ACCOUNT_INFO_ERROR2: 'ACCOUNT_INFO_ERROR2',
};

//annual-report-group
export const annualReportGroupConst = {
  GET_ANNUAL_REPORT_GROUP: 'GET_ANNUAL_REPORT_GROUP',
  GET_ANNUAL_REPORT_GROUP_SUCCESS: 'GET_ANNUAL_REPORT_GROUP_SUCCESS',

  ANNUAL_REPORT_GROUP_PENDING: 'ANNUAL_REPORT_GROUP_PENDING',
  ANNUAL_REPORT_GROUP_RESET_STATE: 'ANNUAL_REPORT_GROUP_RESET_STATE',
  ANNUAL_REPORT_GROUP_ERROR: 'ANNUAL_REPORT_GROUP_ERROR',

  GET_ANNUAL_REPORT_GROUP_PDF: 'GET_ANNUAL_REPORT_GROUP_PDF',
  GET_ANNUAL_REPORT_GROUP_PDF_SUCCESS: 'GET_ANNUAL_REPORT_GROUP_PDF_SUCCESS',

  DOWN_PDF_ANNUAL_GROUP: 'DOWN_PDF_ANNUAL_GROUP',
  DOWN_PDF_ANNUAL_GROUP_SUCCESS: 'DOWN_PDF_ANNUAL_GROUP_SUCCESS',
};

//client-register
export const clientRegisterConst = {
  GET_CLIENT_REGISTER: 'GET_CLIENT_REGISTER',
  GET_CLIENT_REGISTER_SUCCESS: 'GET_CLIENT_REGISTER_SUCCESS',

  GET_VALDIATE_CLIENT_REGISTER: 'GET_VALDIATE_CLIENT_REGISTER',
  GET_VALDIATE_CLIENT_REGISTER_SUCCESS: 'GET_VALDIATE_CLIENT_REGISTER_SUCCESS',

  GET_CLIENT_REGISTER_NEW: 'GET_CLIENT_REGISTER_NEW',
  GET_CLIENT_REGISTER_NEW_SUCCESS: 'GET_CLIENT_REGISTER_NEW_SUCCESS',

  CLIENT_REGISTER_PENDING: 'CLIENT_REGISTER_PENDING',
  CLIENT_REGISTER_RESET_STATE: 'CLIENT_REGISTER_RESET_STATE',
  CLIENT_REGISTER_ERROR: 'CLIENT_REGISTER_ERROR',

  UPDATE_FORGOT_PASSWORD_REGISTER: 'UPDATE_FORGOT_PASSWORD_REGISTER',
  UPDATE_FORGOT_PASSWORD_REGISTER_SUCCESS: 'UPDATE_FORGOT_PASSWORD_REGISTER_SUCCESS',
};

//premium-payment-status
export const prePaymentStatusConst = {
  GET_PAY_STATUS_INVOICE: 'GET_PAY_STATUS_INVOICE',
  GET_PAY_STATUS_INVOICE_SUCCESS: 'GET_PAY_STATUS_INVOICE_SUCCESS',
  GET_PAY_CURRENT_PAGE: 'GET_PAY_CURRENT_PAGE',
  GET_PAY_CURRENT_PAGE_SUCCESS: 'GET_PAY_CURRENT_PAGE_SUCCESS',

  EXPORT_TO_EXCEL: 'EXPORT_TO_EXCEL',
  PREPAYMENT_STATUS_EXPORT_TO_EXCEL_TRANSACTION: 'PREPAYMENT_STATUS_EXPORT_TO_EXCEL_TRANSACTION',
  PREPAYMENT_STATUS_EXPORT_TO_EXCEL_MERCHANT_TRANSACTION:
    'PREPAYMENT_STATUS_EXPORT_TO_EXCEL_MERCHANT_TRANSACTION',

  PAY_STATUS_PENDING: 'PAY_STATUS_PENDING',
  PAY_STATUS_RESET_STATE: 'PAY_STATUS_RESET_STATE',
  PAY_STATUS_ERROR: 'PAY_STATUS_ERROR',

  GET_LIST_MERCHANT: 'GET_LIST_MERCHANT',
  GET_LIST_MERCHANT_SUCCESS: 'GET_LIST_MERCHANT_SUCCESS',
};

//annual-report-personal
export const annualReportPersConst = {
  GET_ANNUAL_REPPORT_PERS_ACC_NUMBER: 'GET_ANNUAL_REPPORT_PERS_ACC_NUMBER',
  GET_ANNUAL_REPPORT_PERS_ACC_NUMBER_SUCCESS: 'GET_ANNUAL_REPPORT_PERS_ACC_NUMBER_SUCCESS',

  GET_LIST_ANNUAL_REPORT_PERS: 'GET_LIST_ANNUAL_REPORT_PERS',
  GET_LIST_ANNUAL_REPORT_PERS_SUCCESS: 'GET_LIST_ANNUAL_REPORT_PERS_SUCCESS',

  ANNUAL_REPPORT_PERS_PENDING: 'ANNUAL_REPPORT_PERS_PENDING',
  ANNUAL_REPPORT_PERS_RESET_STATE: 'ANNUAL_REPPORT_PERS_RESET_STATE',
  ANNUAL_REPPORT_PERS_ERROR: 'ANNUAL_REPPORT_PERS_ERROR',

  GET_ANNUAL_REPORT_PERS_PDF: 'GET_ANNUAL_REPORT_PERS_PDF',
  GET_ANNUAL_REPORT_PERS_PDF_SUCCESS: 'GET_ANNUAL_REPORT_PERS_PDF_SUCCESS',

  GET_LIST_PROPOSAL_PERS: 'GET_LIST_PROPOSAL_PERS',
  GET_LIST_PROPOSAL_PERS_SUCCESS: 'GET_LIST_PROPOSAL_PERS_SUCCESS',

  DOWNLOAD_PDF_REPORT: 'DOWNLOAD_PDF_REPORT',
  DOWNLOAD_PDF_REPORT_SUCCESS: 'DOWNLOAD_PDF_REPORT_SUCCESS',

  DOWNLOAD_PDF_PROPOSAL_REPORT: 'DOWNLOAD_PDF_PROPOSAL_REPORT',
  DOWNLOAD_PDF_PROPOSAL_REPORT_SUCCESS: 'DOWNLOAD_PDF_PROPOSAL_REPORT_SUCCESS',

  GET_PROPOSAL_REPORT_PERS_PDF: 'GET_PROPOSAL_REPORT_PERS_PDF',
  GET_PROPOSAL_REPORT_PERS_PDF_SUCCESS: 'GET_PROPOSAL_REPORT_PERS_PDF_SUCCESS',

  GET_CONFIG_VIEW_PDF: 'GET_CONFIG_VIEW_PDF',
  GET_CONFIG_VIEW_PDF_SUCCESS: 'GET_CONFIG_VIEW_PDF_SUCCESS',
};

//group-ebill
export const groupEBillConst = {
  GET_GROUP_EBILL_LIST: 'GET_GROUP_EBILL_LIST',
  GET_GROUP_EBILL_LIST_SUCCESS: 'GET_GROUP_EBILL_LIST_SUCCESS',

  GROUP_EBILL_PENDING: 'GROUP_EBILL_PENDING',
  GROUP_EBILL_RESET_STATE: 'GROUP_EBILL_RESET_STATE',
  GROUP_EBILL_ERROR: 'GROUP_EBILL_ERROR',

  GET_GROUP_EBILL_PDF: 'GET_GROUP_EBILL_PDF',
  GET_GROUP_EBILL_PDF_SUCCESS: 'GET_GROUP_EBILL_PDF_SUCCESS',

  DOWNLOAD_XML_GROUP_BILL: 'DOWNLOAD_XML_GROUP_BILL',
  DOWNLOAD_XML_GROUP_BILL_SUCCESS: 'DOWNLOAD_XML_GROUP_BILL_SUCCESS',

  DOWNLOAD_PDF_GROUP_BILL: 'DOWNLOAD_PDF_GROUP_BILL',
  DOWNLOAD_PDF_GROUP_BILL_SUCCESS: 'DOWNLOAD_PDF_GROUP_BILL_SUCCESS',
};

//personal-ebill
export const persEBillConst = {
  GET_PERS_EBILL_LIST: 'GET_PERS_EBILL_LIST',
  GET_PERS_EBILL_LIST_SUCCESS: 'GET_PERS_EBILL_LIST_SUCCESS',

  DOWNLOAD_XML_PERS_BUILD: 'DOWNLOAD_XML_PERS_BUILD',
  DOWNLOAD_XML_PERS_BUILD_SUCCESS: 'DOWNLOAD_XML_PERS_BUILD_SUCCESS',

  DOWNLOAD_PDF_PERS_BUILD: 'DOWNLOAD_PDF_PERS_BUILD',
  DOWNLOAD_PDF_PERS_BUILD_SUCCESS: 'DOWNLOAD_PDF_PERS_BUILD_SUCCESS',

  PERS_EBILL_PENDING: 'PERS_EBILL_PENDING',
  PERS_EBILL_RESET_STATE: 'PERS_EBILL_RESET_STATE',
  PERS_EBILL_ERROR: 'PERS_EBILL_ERROR',

  GET_PERS_EBILL_PDF: 'GET_PERS_EBILL_PDF',
  GET_PERS_EBILL_PDF_SUCCESS: 'GET_PERS_EBILL_PDF_SUCCESS',
};

//function-support
export const functionSupportConst = {
  GET_DATA_FUNCTION_SUPPORT: 'GET_DATA_FUNCTION_SUPPORT',
  GET_DATA_FUNCTION_SUPPORT_SUCCESS: 'GET_DATA_FUNCTION_SUPPORT_SUCCESS',

  FUNCTION_SUPPORT_PENDING: 'FUNCTION_SUPPORT_PENDING',
  FUNCTION_SUPPORT_RESET_STATE: 'FUNCTION_SUPPORT_RESET_STATE',
  FUNCTION_SUPPORT_ERROR: 'FUNCTION_SUPPORT_ERROR',
};

//dashboard
export const dashboardConst = {
  GET_DASH_PAV: 'GET_DASH_PAV',
  GET_DASH_PAV_SUCCESS: 'GET_DASH_PAV_SUCCESS',

  GET_DASH_PRE_TRAN: 'GET_DASH_PRE_TRAN',
  GET_DASH_PRE_TRAN_SUCCESS: 'GET_DASH_PRE_TRAN_SUCCESS',

  DASHBOARD_PENDING: 'DASHBOARD_PENDING',
  DASHBOARD_RESET_STATE: 'DASHBOARD_RESET_STATE',
  DASHBOARD_ERROR: 'DASHBOARD_ERROR',
};

//update-acc-info
export const updateAccInfoConst = {
  UPDATE_ACC_INFO_UPDATE_PASS: 'UPDATE_ACC_INFO_UPDATE_PASS',
  UPDATE_ACC_INFO_UPDATE_PASS_SUCCESS: 'UPDATE_ACC_INFO_UPDATE_PASS_SUCCESS',

  UPDATE_ACC_INFO_UPDATE_ALIAS: 'UPDATE_ACC_INFO_UPDATE_ALIAS',
  UPDATE_ACC_INFO_UPDATE_ALIAS_SUCCESS: 'UPDATE_ACC_INFO_UPDATE_ALIAS_SUCCESS',

  UPDATE_ACC_INFO_PENDING: 'UPDATE_ACC_INFO_PENDING',
  UPDATE_ACC_INFO_RESET_STATE: 'UPDATE_ACC_INFO_RESET_STATE',

  SEARCH_AGENT_INFO: 'SEARCH_AGENT_INFO',
  SEARCH_AGENT_INFO_SUCCESS: 'SEARCH_AGENT_INFO_SUCCESS',

  SEARCH_AGENT_NAME_UPDATE: 'SEARCH_AGENT_NAME_UPDATE',
  SEARCH_AGENT_NAME_UPDATE_SUCCESS: 'SEARCH_AGENT_NAME_UPDATE_SUCCESS',

  SEARCH_AGENT_CODE_UPDATE: 'SEARCH_AGENT_CODE_UPDATE',
  SEARCH_AGENT_CODE_UPDATE_SUCCESS: 'SEARCH_AGENT_CODE_UPDATE_SUCCESS',

  UPDATE_AGENT_NUMBER: 'UPDATE_AGENT_NUMBER',
  UPDATE_AGENT_NUMBER_SUCCESS: 'UPDATE_AGENT_NUMBER_SUCCESS',

  ON_UPDATE_PASSWORD: 'ON_UPDATE_PASSWORD',
  ON_UPDATE_PASSWORD_SUCCESS: 'ON_UPDATE_PASSWORD_SUCCESS',

  UPDATE_ACC_INFO_ERROR: 'UPDATE_ACC_INFO_ERROR',
};

//loyalty-acc-info
export const loyaltyAccInfoConst = {
  LOYALTY_ACC_INFO_UPDATE_PASS: 'LOYALTY_ACC_INFO_UPDATE_PASS',
  LOYALTY_ACC_INFO_UPDATE_PASS_SUCCESS: 'LOYALTY_ACC_INFO_UPDATE_PASS_SUCCESS',

  LOYALTY_ACC_INFO_UPDATE_ALIAS: 'LOYALTY_ACC_INFO_UPDATE_ALIAS',
  LOYALTY_ACC_INFO_UPDATE_ALIAS_SUCCESS: 'LOYALTY_ACC_INFO_UPDATE_ALIAS_SUCCESS',

  LOYALTY_ACC_INFO_PENDING: 'LOYALTY_ACC_INFO_PENDING',
  LOYALTY_ACC_INFO_RESET_STATE: 'LOYALTY_ACC_INFO_RESET_STATE',

  //SEARCH_AGENT_INFO: 'SEARCH_AGENT_INFO',
  //SEARCH_AGENT_INFO_SUCCESS: 'SEARCH_AGENT_INFO_SUCCESS',

  SEARCH_AGENT_NAME: 'SEARCH_AGENT_NAME',
  SEARCH_AGENT_NAME_SUCCESS: 'SEARCH_AGENT_NAME_SUCCESS',

  SEARCH_AGENT_CODE: 'SEARCH_AGENT_CODE',
  SEARCH_AGENT_CODE_SUCCESS: 'SEARCH_AGENT_CODE_SUCCESS',

  LOYALTY_AGENT_NUMBER: 'LOYALTY_AGENT_NUMBER',
  LOYALTY_AGENT_NUMBER_SUCCESS: 'LOYALTY_AGENT_NUMBER_SUCCESS',

  GET_LOYALTY_FUNCTION_SUPPORT: 'GET_LOYALTY_FUNCTION_SUPPORT',
  GET_LOYALTY_FUNCTION_SUPPORT_SUCCESS: 'GET_LOYALTY_FUNCTION_SUPPORT_SUCCESS',

  GET_LOYALTY_GIFTGROUP: 'GET_LOYALTY_GIFTGROUP',
  GET_LOYALTY_GIFTGROUP_SUCCESS: 'GET_LOYALTY_GIFTGROUP_SUCCESS',
  GET_LOYALTY_GIFTGROUP_ERROR: 'GET_LOYALTY_GIFTGROUP_ERROR',

  GET_LOYALTY_OWNGIFT_USED: 'GET_LOYALTY_OWNGIFT_USED',
  GET_LOYALTY_OWNGIFT_USED_SUCCESS: 'GET_LOYALTY_OWNGIFT_USED_SUCCESS',
  GET_LOYALTY_OWNGIFT_UNUSED: 'GET_LOYALTY_OWNGIFT_UNUSED',
  GET_LOYALTY_OWNGIFT_UNUSED_SUCCESS: 'GET_LOYALTY_OWNGIFT_UNUSED_SUCCESS',

  GET_LOYALTY_TRANSACTION: 'GET_LOYALTY_TRANSACTION',
  GET_LOYALTY_TRANSACTION_SUCCESS: 'GET_LOYALTY_TRANSACTION_SUCCESS',

  GET_LOYALTY_GIFTINFORS: 'GET_LOYALTY_GIFTINFORS',
  GET_LOYALTY_GIFTINFORS_SUCCESS: 'GET_LOYALTY_GIFTINFORS_SUCCESS',
  GET_LOYALTY_GIFTINFORS_ERROR: 'GET_LOYALTY_GIFTINFORS_ERROR',

  GET_LOYALTY_GETREDEEMTOKEN: 'GET_LOYALTY_GETREDEEMTOKEN',
  GET_LOYALTY_GETREDEEMTOKEN_SUCCESS: 'GET_LOYALTY_GETREDEEMTOKEN_SUCCESS',
  GET_LOYALTY_GETREDEEMTOKEN_ERROR: 'GET_LOYALTY_GETREDEEMTOKEN_ERROR',

  GET_LOYALTY_CHALLENGE: 'GET_LOYALTY_CHALLENGE',
  GET_LOYALTY_CHALLENGE_SUCCESS: 'GET_LOYALTY_CHALLENGE_SUCCESS',
  GET_LOYALTY_CHALLENGE_ERROR: 'GET_LOYALTY_CHALLENGE_ERROR',

  GET_LOYALTY_REWARD: 'GET_LOYALTY_REWARD',
  GET_LOYALTY_REWARD_SUCCESS: 'GET_LOYALTY_REWARD_SUCCESS',
  GET_LOYALTY_REWARD_ERROR: 'GET_LOYALTY_REWARD_ERROR',

  GET_LOYALTY_GETPROFILEBYC: 'GET_LOYALTY_GETPROFILEBYC',
  GET_LOYALTY_GETPROFILEBYC_SUCCESS: 'GET_LOYALTY_GETPROFILEBYC_SUCCESS',
  GET_LOYALTY_GETPROFILEBYC_ERROR: 'GET_LOYALTY_GETPROFILEBYC_ERROR',

  STORE_GIFT_GETALL_BYMEMBERCODE: 'STORE_GIFT_GETALL_BYMEMBERCODE',
  STORE_GIFT_GETALL_BYMEMBERCODE_SUCCESS: 'STORE_GIFT_GETALL_BYMEMBERCODE_SUCCESS',
  STORE_GIFT_GETALL_BYMEMBERCODE_ERROR: 'STORE_GIFT_GETALL_BYMEMBERCODE_ERROR',

  STORE_GIFT_GETALL_BYGROUPCODE: 'STORE_GIFT_GETALL_BYGROUPCODE',
  STORE_GIFT_GETALL_BYGROUPCODE_SUCCESS: 'STORE_GIFT_GETALL_BYGROUPCODE_SUCCESS',
  STORE_GIFT_GETALL_BYGROUPCODE_ERROR: 'STORE_GIFT_GETALL_BYGROUPCODE_ERROR',

  LOYALTY_SUPPORT_ERROR: 'LOYALTY_SUPPORT_ERROR',
  LOYALTY_SUPPORT_ERROR_SUCCESS: 'LOYALTY_SUPPORT_ERROR_SUCCESS',
  LOYALTY_SUPPORT_ERROR_ERROR: 'LOYALTY_SUPPORT_ERROR_ERROR',

  CHALLENGE_DETAIL: 'CHALLENGE_DETAIL',
  CHALLENGE_DETAIL_SUCCESS: 'CHALLENGE_DETAIL_SUCCESS',
  CHALLENGE_DETAIL_ERRor: 'CHALLENGE_DETAIL_ERRor',

  LOYALTY_ACC_INFO_ERROR: 'LOYALTY_ACC_INFO_ERROR',
  LOYALTY_ACC_INFO_ERROR_SUCCESS: 'LOYALTY_ACC_INFO_ERROR_SUCCESS',

  GIFT_GETALL_BYMEMBERCODE: 'GIFT_GETALL_BYMEMBERCODE',
  GIFT_GETALL_BYMEMBERCODE_SUCCESS: 'GIFT_GETALL_BYMEMBERCODE_SUCCESS',

  GIFT_GETALL_GETALLWITHIMAGE: 'GIFT_GETALL_GETALLWITHIMAGE',
  GIFT_GETALL_GETALLWITHIMAGE_SUCCESS: 'GIFT_GETALL_GETALLWITHIMAGE_SUCCESS',
  GIFT_GETALL_GETALLWITHIMAGE_ERROR: 'GIFT_GETALL_GETALLWITHIMAGE_ERROR',

  GIFT_GROUPDETAIL_GIFTGROUP: 'GIFT_GROUPDETAIL_GIFTGROUP',
  GIFT_GROUPDETAIL_GIFTGROUP_SUCCESS: 'GIFT_GROUPDETAIL_GIFTGROUP_SUCCESS',
  GIFT_GROUPDETAIL_GIFTGROUP_ERROR: 'GIFT_GROUPDETAIL_GIFTGROUP_ERROR',

  GIFT_GETALL_GETALLFORCATEGORY: 'GIFT_GETALL_GETALLFORCATEGORY',
  GIFT_GETALL_GETALLFORCATEGORY_SUCCESS: 'GIFT_GETALL_GETALLFORCATEGORY_SUCCESS',
  GIFT_GETALL_GETALLFORCATEGORY_ERROR: 'GIFT_GETALL_GETALLFORCATEGORY_ERROR',

  GIFT_GETALL_GETALLFORCATEGORY_PENDING: 'GIFT_GETALL_GETALLFORCATEGORY_PENDING',
  GIFT_GETALL_GETALLFORCATEGORY_PENDING_SUCCESS: 'GIFT_GETALL_GETALLFORCATEGORY_PENDING_SUCCESS',

  GIFT_VOUCHER_ERROR_ACC_INFO: 'GIFT_VOUCHER_ERROR_ACC_INFO',
  GIFT_VOUCHER_ERROR_ACC_INFO_SUCCESS: 'GIFT_VOUCHER_ERROR_ACC_INFO_SUCCESS',
  GIFT_VOUCHER_ERROR_ACC_INFO_ERROR: 'GIFT_VOUCHER_ERROR_ACC_INFO_ERROR',

  GIFT_CREAT_REDEEM_TRANSACTION: 'GIFT_CREAT_REDEEM_TRANSACTION',
  GIFT_CREAT_REDEEM_TRANSACTION_SUCCESS: 'GIFT_CREAT_REDEEM_TRANSACTION_SUCCESS',
  GIFT_CREAT_REDEEM_TRANSACTION_ERROR: 'GIFT_CREAT_REDEEM_TRANSACTION_ERROR',

  GIFT_INFOR_UPDATE_STATUS: 'GIFT_INFOR_UPDATE_STATUS',
  GIFT_INFOR_UPDATE_STATUS_SUCCESS: 'GIFT_INFOR_UPDATE_STATUS_SUCCESS',
  GIFT_INFOR_UPDATE_STATUS_ERROR: 'GIFT_INFOR_UPDATE_STATUS_ERROR',

  GIFT_CREAT_REDEEM_HISTORY: 'GIFT_CREAT_REDEEM_HISTORY',
  GIFT_CREAT_REDEEM_HISTORY_SUCCESS: 'GIFT_CREAT_REDEEM_HISTORY_SUCCESS',
  GIFT_CREAT_REDEEM_HISTORY_ERROR: 'GIFT_CREAT_REDEEM_HISTORY_ERROR',

  GIFT_VOUCHER_RESET_ACC_INFO: 'GIFT_VOUCHER_RESET_ACC_INFO',
  GIFT_VOUCHER_RESET_ACC_INFO_SUCCESS: 'GIFT_VOUCHER_RESET_ACC_INFO_SUCCESS',
  GIFT_VOUCHER_RESET_ACC_INFO_ERROR: 'GIFT_VOUCHER_RESET_ACC_INFO_ERROR',

  GIFT_CATEGORY_GETALL_MENU: 'GIFT_CATEGORY_GETALL_MENU',
  GIFT_CATEGORY_GETALL_MENU_SUCCESS: 'GIFT_CATEGORY_GETALL_MENU_SUCCESS',
  GIFT_CATEGORY_GETALL_MENU_ERROR: 'GIFT_CATEGORY_GETALL_MENU_ERROR',

  GIFT_QUEST_GETALL: 'GIFT_QUEST_GETALL',
  GIFT_QUEST_GETALL_SUCCESS: 'GIFT_QUEST_GETALL_SUCCESS',
  GIFT_QUEST_GETALL_ERROR: 'GIFT_QUEST_GETALL_ERROR',

  LOYALTY_ACC_PROFILE_MEMBER: 'LOYALTY_ACC_PROFILE_MEMBER',
  LOYALTY_ACC_PROFILE_MEMBER_SUCCESS: 'LOYALTY_ACC_PROFILE_MEMBER_SUCCESS',
  LOYALTY_ACC_PROFILE_MEMBER_ERROR: 'LOYALTY_ACC_PROFILE_MEMBER_ERROR',

  GIFT_VOUCHE_DETAIL: 'GIFT_VOUCHE_DETAIL',
  GIFT_VOUCHE_DETAIL_SUCCESS: 'GIFT_VOUCHE_DETAIL_SUCCESS',
  GIFT_VOUCHE_DETAIL_ERROR: 'GIFT_VOUCHE_DETAIL_ERROR',

  GIFT_MODAL_REDEEM_GIFT_CITYCODE: 'GIFT_MODAL_REDEEM_GIFT_CITYCODE',
  GIFT_MODAL_REDEEM_GIFT_CITYCODE_SUCCESS: 'GIFT_MODAL_REDEEM_GIFT_CITYCODE_SUCCESS',
  GIFT_MODAL_REDEEM_GIFT_CITYCODE_ERROR: 'GIFT_MODAL_REDEEM_GIFT_CITYCODE_ERROR',

  GIFT_MODAL_REDEEM_GIFT_TOWNCODE: 'GIFT_MODAL_REDEEM_GIFT_TOWNCODE',
  GIFT_MODAL_REDEEM_GIFT_TOWNCODE_SUCCESS: 'GIFT_MODAL_REDEEM_GIFT_TOWNCODE_SUCCESS',
  GIFT_MODAL_REDEEM_GIFT_TOWNCODE_ERROR: 'GIFT_MODAL_REDEEM_GIFT_TOWNCODE_ERROR',

  GIFT_MODAL_REDEEM_GIFT_VILLAGECODE: 'GIFT_MODAL_REDEEM_GIFT_VILLAGECODE',
  GIFT_MODAL_REDEEM_GIFT_VILLAGECODE_SUCCESS: 'GIFT_MODAL_REDEEM_GIFT_VILLAGECODE_SUCCESS',
  GIFT_MODAL_REDEEM_GIFT_VILLAGECODE_ERROR: 'GIFT_MODAL_REDEEM_GIFT_VILLAGECODE_ERROR',

  GIFT_PASS_DATA_REDEEM: 'GIFT_PASS_DATA_REDEEM',
  GIFT_PASS_DATA_REDEEM_SUCCESS: 'GIFT_PASS_DATA_REDEEM_SUCCESS',
  GIFT_PASS_DATA_REDEEM_ERROR: 'GIFT_PASS_DATA_REDEEM_ERROR',

  GET_LOYALTY_REWARD_ERROR: 'GET_LOYALTY_REWARD_ERROR',
  GET_LOYALTY_FUNCTION_SUPPORT_ERROR: 'GET_LOYALTY_FUNCTION_SUPPORT_ERROR',

  GET_LOYALTY_SCROLLING_MENU: 'GET_LOYALTY_SCROLLING_MENU',

  GIFT_CHECK_MINIGAME: 'GIFT_CHECK_MINIGAME',
  GIFT_CHECK_MINIGAME_SUCCESS: 'GIFT_CHECK_MINIGAME_SUCCESS',
};

//loyalty-acc-info
export const loyaltyQuestConst = {
  LOYALTY_QUEST_GET_ALL: 'LOYALTY_QUEST_GET_ALL',
  LOYALTY_QUEST_GET_ALL_SUCCESS: 'LOYALTY_QUEST_GET_ALL_SUCCESS',

  LOYALTY_QUEST_GET_DETAIL: 'LOYALTY_QUEST_GET_DETAIL',
  LOYALTY_QUEST_GET_DETAIL_SUCCESS: 'LOYALTY_QUEST_GET_DETAIL_SUCCESS',

  LOYALTY_QUEST_GET_BY_ACTIVITY: 'LOYALTY_QUEST_GET_BY_ACTIVITY',
  LOYALTY_QUEST_GET_BY_ACTIVITY_SUCCESS: 'LOYALTY_QUEST_GET_BY_ACTIVITY_SUCCESS',

  LOYALTY_QUEST_PENDING: 'LOYALTY_QUEST_PENDING',
  LOYALTY_QUEST_ERROR: 'LOYALTY_QUEST_ERROR',
  LOYALTY_QUEST_ACC_RESET_STATE: 'LOYALTY_QUEST_ACC_RESET_STATE',

  LOYALTY_QUEST_JOIN_CREAT: 'LOYALTY_QUEST_JOIN_CREAT',
  LOYALTY_QUEST_JOIN_CREAT_SUCCESS: 'LOYALTY_QUEST_JOIN_CREAT_SUCCESS',
};

//create-new-Acc
export const createNewAccConst = {
  GET_GEN_USER_CODE: 'GET_GEN_USER_CODE',
  GET_GEN_USER_CODE_SUCCESS: 'GET_GEN_USER_CODE_SUCCESS',

  GET_RESPONE_INSERT_NEW_ACC: 'GET_RESPONE_INSERT_NEW_ACC',
  GET_RESPONE_INSERT_NEW_ACC_SUCCESS: 'GET_RESPONE_INSERT_NEW_ACC_SUCCESS',

  CREATE_NEW_ACC_PENDING: 'CREATE_NEW_ACC_PENDING',
  CREATE_NEW_ACC_RESET_STATE: 'CREATE_NEW_ACC_RESET_STATE',
  CREATE_NEW_ACC_ERROR: 'CREATE_NEW_ACC_ERROR',
};

//online-trading
export const onlineTradingConst = {
  ONLINE_TRADING_GET_GENERAL_INFO: 'ONLINE_TRADING_GET_GENERAL_INFO',
  ONLINE_TRADING_GET_GENERAL_INFO_SUCCESS: 'ONLINE_TRADING_GET_GENERAL_INFO_SUCCESS',

  ONLINE_TRADING_GET_CUSTOMER_INFO: 'ONLINE_TRADING_GET_CUSTOMER_INFO',
  ONLINE_TRADING_GET_CUSTOMER_INFO_SUCCESS: 'ONLINE_TRADING_GET_CUSTOMER_INFO_SUCCESS',

  ONLINE_TRADING_GET_LOAN_VALUE: 'ONLINE_TRADING_GET_LOAN_VALUE',
  ONLINE_TRADING_GET_LOAN_VALUE_SUCCESS: 'ONLINE_TRADING_GET_LOAN_VALUE_SUCCESS',

  ONLINE_TRADING_UPDATE_INFO_CHANGE: 'ONLINE_TRADING_UPDATE_INFO_CHANGE',
  ONLINE_TRADING_UPDATE_INFO_CHANGE_SUCCESS: 'ONLINE_TRADING_UPDATE_INFO_CHANGE_SUCCESS',

  GET_LIST_TRANS_HISTORY: 'GET_LIST_TRANS_HISTORY',
  GET_LIST_TRANS_HISTORY_SUCCESS: 'GET_LIST_TRANS_HISTORY_SUCCESS',

  ONLINE_TRADING_PENDING: 'ONLINE_TRADING_PENDING',
  ONLINE_TRADING_RESET_STATE: 'ONLINE_TRADING_RESET_STATE',
  ONLINE_TRADING_ERROR: 'ONLINE_TRADING_ERROR',
};

//upload
export const uploadConst = {
  UPLOAD_IMAGE: 'UPLOAD_IMAGE',
  UPLOAD_IMAGE_SUCCESS: 'UPLOAD_IMAGE_SUCCESS',

  UPLOAD_PENDING: 'UPLOAD_PENDING',
  UPLOAD_RESET_STATE: 'UPLOAD_RESET_STATE',
  UPLOAD_ERROR: 'UPLOAD_ERROR',
};

//activity-log
export const activityLogConst = {
  ACTIVITY_LOG_GET_ALL: 'ACTIVITY_LOG_GET_ALL',
  ACTIVITY_LOG_GET_ALL_SUCCESS: 'ACTIVITY_LOG_GET_ALL_SUCCESS',

  ACTIVITY_LOG_PENDING: 'ACTIVITY_LOG_PENDING',

  ACTIVITY_LOG_RESET_STATE: 'ACTIVITY_LOG_RESET_STATE',
  ACTIVITY_LOG_ERROR: 'ACTIVITY_LOG_ERROR',
};

export const exportExcelConst = {
  EXPORT_EXCEL_PENDING: 'EXPORT_EXCEL_PENDING',
  EXPORT_EXCEL_PENDING_SUCCESS: 'EXPORT_EXCEL_PENDING_SUCCESS',

  EXPORT_EXCEL_RESET_STATE: 'EXPORT_EXCEL_RESET_STATE',
  EXPORT_EXCEL_ERROR: 'EXPORT_EXCEL_ERROR',
};

export const forgotPasswordConst = {
  UPDATE_FORGOT_PASSWORD: 'UPDATE_FORGOT_PASSWORD',
  UPDATE_FORGOT_PASSWORD_SUCCESS: 'UPDATE_FORGOT_PASSWORD_SUCCESS',

  UPDATE_FORGOT_PASSWORD_PENDING: 'UPDATE_FORGOT_PASSWORD_PENDING',
  UPDATE_FORGOT_PASSWORD_ERROR: 'UPDATE_FORGOT_PASSWORD_ERROR',
  UPDATE_FORGOT_PASSWORD_RESET_STATE: 'UPDATE_FORGOT_PASSWORD_RESET_STATE',
};

export const notificationConst = {
  NOTIFICATION_INIT: 'NOTIFICATION_INIT',
  NOTIFICATION_INIT_SUCCESS: 'NOTIFICATION_INIT_SUCCESS',

  NOTIFICATION_GROUP_GET_ALL: 'NOTIFICATION_GROUP_GET_ALL',
  NOTIFICATION_GROUP_GET_ALL_SUCCESS: 'NOTIFICATION_GROUP_GET_ALL_SUCCESS',

  NOTIFICATION_PENDING: 'NOTIFICATION_PENDING',
  NOTIFICATION_ERROR: 'NOTIFICATION_ERROR',
  NOTIFICATION_RESET_STATE: 'NOTIFICATION_RESET_STATE',

  NOTIFICATION_ALL_FUNC_MENUS: 'NOTIFICATION_ALL_FUNC_MENUS',
  NOTIFICATION_ALL_FUNC_MENUS_SUCCESS: 'NOTIFICATION_ALL_FUNC_MENUS_SUCCESS',

  NOTIFICATION_ADD_NOTIFICATION: 'NOTIFICATION_ADD_NOTIFICATION',
  NOTIFICATION_ADD_NOTIFICATION_SUCCESS: 'NOTIFICATION_ADD_NOTIFICATION_SUCCESS',
};

export const notifyAllConst = {
  NOTIFY_ALL_GET_ALL: 'NOTIFY_ALL_GET_ALL',
  NOTIFY_ALL_GET_ALL_SUCCESS: 'NOTIFY_ALL_GET_ALL_SUCCESS',

  NOTIFY_ALL_PENDING: '  NOTIFY_ALL_PENDING',
  NOTIFY_ALL_ERROR: '  NOTIFY_ALL_ERROR',
  NOTIFY_ALL_RESET_STATE: 'NOTIFY_ALL_RESET_STATE',
};

export const mobileUpdateAppConst = {
  VERSION_APP_PENDING: 'VERSION_APP_PENDING',
  VERSION_APP_ERROR: 'VERSION_APP_ERROR',
  VERSION_APP_RESET_STATE: 'VERSION_APP_RESET_STATE',

  ADD_MOBILE_APP_INFO: 'ADD_MOBILE_APP_INFO',
  ADD_MOBILE_APP_INFO_SUCCESS: 'ADD_MOBILE_APP_INFO_SUCCESS',

  SEARCH_MOBILE_APP_VERSION: 'SEARCH_MOBILE_APP_VERSION',
  SEARCH_MOBILE_APP_VERSION_SUCCESS: 'SEARCH_MOBILE_APP_VERSION_SUCCESS',

  UPDATE_MOBILE_APP_INFO: 'UPDATE_MOBILE_APP_INFO',
  UPDATE_MOBILE_APP_INFO_SUCCESS: 'UPDATE_MOBILE_APP_INFO_SUCCESS',

  DELETE_MOBILE_APP_VERSION: 'DELETE_MOBILE_APP_VERSION',
  DELETE_MOBILE_APP_VERSION_SUCCESS: 'DELETE_MOBILE_APP_VERSION_SUCCESS',
};

export const insurranceOnlineConst = {
  INSURRANCE_ONLINE_PENDING: 'INSURRANCE_ONLINE_PENDING',
  INSURRANCE_ONLINE_ERROR: 'INSURRANCE_ONLINE_ERROR',
  INSURRANCE_ONLINE_RESET_STATE: 'INSURRANCE_ONLINE_RESET_STATE',

  INSURRANCE_GET_MERCHANT: 'INSURRANCE_GET_MERCHANT',
  INSURRANCE_GET_MERCHANT_SUCCESS: 'INSURRANCE_GET_MERCHANT_SUCCESS',

  INSURRANCE_GET_PRODUCT_PLAN: 'INSURRANCE_GET_PRODUCT_PLAN',
  INSURRANCE_GET_PRODUCT_PLAN_SUCCESS: 'INSURRANCE_GET_PRODUCT_PLAN_SUCCESS',
  INSURRANCE_CHECK_AUTHENTICATE: 'INSURRANCE_CHECK_AUTHENTICATE',
  INSURRANCE_CHECK_AUTHENTICATE_SUCCESS: 'INSURRANCE_CHECK_AUTHENTICATE_SUCCESS',

  SET_LOADING_PRODUCT_PLAN: 'SET_LOADING_PRODUCT_PLAN',
  INSURRANCE_UPDATE_MESSAGE_ERROR: 'INSURRANCE_UPDATE_MESSAGE_ERROR',

  INSURRANCE_UPDATE_TRANSACTION: 'INSURRANCE_UPDATE_TRANSACTION',
  INSURRANCE_UPDATE_TRANSACTION_SUCCESS: 'INSURRANCE_UPDATE_TRANSACTION_SUCCESS',

  INSURRANCE_SAVE_ERROR: 'INSURRANCE_SAVE_ERROR',

  INSURRANCE_GET_CITY: 'INSURRANCE_GET_CITY',
  INSURRANCE_GET_CITY_SUCCESS: 'INSURRANCE_GET_CITY_SUCCESS',

  INSURRANCE_ADDRESS: 'INSURRANCE_ADDRESS',
  INSURRANCE_ADDRESS_SUCCESS: 'INSURRANCE_ADDRESS_SUCCESS',

  INSURRANCE_STEP: 'INSURRANCE_STEP',

  INSURRANCE_GET_TOWN: 'INSURRANCE_GET_TOWN',
  INSURRANCE_GET_TOWN_SUCCESS: 'INSURRANCE_GET_TOWN_SUCCESS',

  INSURRANCE_GET_VILLAGE: 'INSURRANCE_GET_VILLAGE',
  INSURRANCE_GET_VILLAGE_SUCCESS: 'INSURRANCE_GET_VILLAGE_SUCCESS',

  INSURRANCE_GET_OUTLETCODE: 'INSURRANCE_GET_OUTLETCODE',
  INSURRANCE_GET_OUTLETCODE_SUCCESS: 'INSURRANCE_GET_OUTLETCODE_SUCCESS',

  INSURRANCE_GET_OUTLETNAME: 'INSURRANCE_GET_OUTLETNAME',
  INSURRANCE_GET_OUTLETNAME_SUCCESS: 'INSURRANCE_GET_OUTLETNAME_SUCCESS',

  INSURRANCE_CREAT_PROPOSAL: 'INSURRANCE_CREAT_PROPOSAL',
  INSURRANCE_CREAT_PROPOSAL_SUCCESS: 'INSURRANCE_CREAT_PROPOSAL_SUCCESS',

  INSURRANCE_SAVE_CUSTOMER: 'INSURRANCE_SAVE_CUSTOMER',
  INSURRANCE_SAVE_CUSTOMER_SUCCESS: 'INSURRANCE_SAVE_CUSTOMER_SUCCESS',

  INSURRANCE_GENERAL_OTP: 'INSURRANCE_GENERAL_OTP',
  INSURRANCE_GENERAL_OTP_SUCCESS: 'INSURRANCE_GENERAL_OTP_SUCCESS',

  INSURRANCE_CONFIRM_OTP: 'INSURRANCE_CONFIRM_OTP',
  INSURRANCE_CONFIRM_OTP_SUCCESS: 'INSURRANCE_CONFIRM_OTP_SUCCESS',

  INSURRANCE_NAPAS_URL: 'INSURRANCE_NAPAS_URL',
  INSURRANCE_NAPAS_URL_SUCCESS: 'INSURRANCE_NAPAS_URL_SUCCESS',

  INSURRANCE_ONLINE_DOCTYPE: 'INSURRANCE_ONLINE_DOCTYPE',
  INSURRANCE_ONLINE_DOCTYPE_SUCCESS: 'INSURRANCE_ONLINE_DOCTYPE_SUCCESS',

  INSURRANCE_ONLINE_DOCTYPE_BENE: 'INSURRANCE_ONLINE_DOCTYPE_BENE',
  INSURRANCE_ONLINE_DOCTYPE_BENE_SUCCESS: 'INSURRANCE_ONLINE_DOCTYPE_BENE_SUCCESS',

  INSURRANCE_ONLINE_BENEFICIARYNAMERELT: 'INSURRANCE_ONLINE_BENEFICIARYNAMERELT',
  INSURRANCE_ONLINE_BENEFICIARYNAMERELT_SUCCESS: 'INSURRANCE_ONLINE_BENEFICIARYNAMERELT_SUCCESS',

  INSURRANCE_ONLINE_ISSUINGAUTHORITY: 'INSURRANCE_ONLINE_ISSUINGAUTHORITY',
  INSURRANCE_ONLINE_ISSUINGAUTHORITY_SUCCESS: 'INSURRANCE_ONLINE_ISSUINGAUTHORITY_SUCCESS',

  INSURRANCE_DATA_MERCHANT: 'INSURRANCE_DATA_MERCHANT',
};
export const persContractDocument = {
  GET_PERS_CONTRACT_TYPE_CONTENT: 'GET_PERS_CONTRACT_TYPE_CONTENT',
  GET_PERS_CONTRACT_TYPE_CONTENT_SUCCESS: 'GET_PERS_CONTRACT_TYPE_CONTENT_SUCCESS',

  SEARCH_CS_REQUEST: 'SEARCH_CS_REQUEST',
  SEARCH_CS_REQUEST_SUCCESS: 'SEARCH_CS_REQUEST_SUCCESS',

  CREATE_CS_REQUEST: 'CREATE_CS_REQUEST',
  CREATE_CS_REQUEST_SUCCESS: 'CREATE_CS_REQUEST_SUCCESS',

  UPDATE_CS_REQUEST: 'UPDATE_CS_REQUEST',
  UPDATE_CS_REQUEST_SUCCESS: 'UPDATE_CS_REQUEST_SUCCESS',

  PERS_CONTRACT_DOCUMENT_RESET_STATE: 'PERS_CONTRACT_DOCUMENT_RESET_STATE',
  PERS_CONTRACT_DOCUMENT_RESET_UPDATE: 'PERS_CONTRACT_DOCUMENT_RESET_UPDATE',
};
export const manageMerchantConst = {
  GET_MERCHANT: 'GET_MERCHANT',
  GET_MERCHANT_SUCCESS: 'GET_MERCHANT_SUCCESS',
  GET_USERS: 'GET_USERS',
  GET_USERS_SUCCESS: 'GET_USERS_SUCCESS',
  SAVE_MERCHANT: 'SAVE_MERCHANT',
  SAVE_MERCHANT_SUCCESS: 'SAVE_MERCHANT_SUCCESS',
};

export const ekyc = {
  SET_INFO_CUSTOMER: 'EKYC_SET_INFO_CUSTOMER',
  SET_INFO_EKYC: 'EKYC_SET_INFO_EKYC',
  SET_PARAM_URL: 'EKYC_SET_PARAM_URL',
  SET_CURRENT_PAGE: 'EKYC_SET_CURRENT_PAGE',
  START_FETCHING: 'EKYC_START_FETCHING',
  STOP_FETCHING: 'EKYC_STOP_FETCHING',
  SET_STATUS_VERIFY: 'EKYC_SET_STATUS_VERIFY',
  SET_DATA_API_VALIDATE_LINK: 'SET_DATA_API_VALIDATE_LINK',
  SET_DATA_BY_LINK_LOGIN_EKYC: 'SET_DATA_BY_LINK_LOGIN_EKYC',
  SET_DATA_API_SUBMIT: 'SET_DATA_API_SUBMIT',
  SET_DATA_FORM: 'SET_DATA_FORM',
  UPDATE_MEM_STOP_EKYC: 'UPDATE_MEM_STOP_EKYC',
};

export const CONTRACT_ACTION = {
  START_FETCHING: 'CONTRACT_START_FETCHING',
  STOP_FETCHING: 'CONTRACT_STOP_FETCHING',
  START_FETCHING_BUYER: 'CONTRACT_START_FETCHING_BUYER',
  STOP_FETCHING_BUYER: 'CONTRACT_STOP_FETCHING_BUYER',
  START_FETCHING_PRODUCT: 'CONTRACT_START_FETCHING_PRODUCT',
  STOP_FETCHING_PRODUCT: 'CONTRACT_STOP_FETCHING_PRODUCT',
  START_FETCHING_FEE: 'CONTRACT_START_FETCHING_FEE',
  STOP_FETCHING_FEE: 'CONTRACT_STOP_FETCHING_FEE',
  START_FETCHING_DOCUMENT: 'CONTRACT_START_FETCHING_DOCUMENT',
  STOP_FETCHING_DOCUMENT: 'CONTRACT_STOP_FETCHING_DOCUMENT',
  START_FETCHING_INVOICE: 'CONTRACT_START_FETCHING_INVOICE',
  STOP_FETCHING_INVOICE: 'CONTRACT_STOP_FETCHING_INVOICE',

  SET_CONTRACTS: 'CONTRACT_SET_CONTRACTS',
  SET_CURRENT_CONTRACT: 'CONTRACT_SET_CURRENT_CONTRACT',
  SET_BUYER: 'CONTRACT_SET_BUYER',
  SET_PRODUCT: 'CONTRACT_SET_PRODUCT',
  SET_FEE: 'CONTRACT_SET_FEE',
  SET_DOCUMENT: 'CONTRACT_SET_DOCUMENT',
  SET_REPORT_YEAR: 'CONTRACT_SET_REPORT_YEAR',
  SET_PROPOSAL: 'CONTRACT_SET_PROPOSAL',
  RESET_A_CONTRACT: 'CONTRACT_RESET_A_CONTRACT',
  RESET: 'CONTRACT_RESET',
  SET_INVOICE: 'CONTRACT_SET_INVOICE',
  SET_BENEFITS: 'CONTRACT_SET_BENEFITS',
  SET_BENEFITS_CONTRACT: 'CONTRACT_SET_BENEFITS_CONTRACT',
  SET_POPUP_LOYALTY: 'SET_POPUP_LOYALTY',
};

export const csOnline = {
  START_FETCHING: 'CS_ONLINE_START_FETCHING',
  STOP_FETCHING: 'CS_ONLINE_STOP_FETCHING',
  SET_STEP_CREATE: 'CS_ONLINE_SET_STEP_CREATE',
  RESET_CREATE: 'CS_ONLINE_RESET_CREATE',
  INFO_CS_ONLINE: 'CS_ONLINE_INFO_CS_ONLINE',
  LIST_POLICY_OF_USER_NOT_REGISTER: 'CS_ONLINE_LIST_POLICY_OF_USER_NOT_REGISTER',
  LIST_CONTRACT_REGISTER_CS_ONLINE: 'CS_ONLINE_LIST_CONTRACT_REGISTER_CS_ONLINE',
  LIST_IDS_OCR: 'CS_ONLINE_LIST_IDS_OCR',
  SET_RESULT_OTP: 'CS_ONLINE_SET_RESULT_OTP',
  SET_REQUEST_NUMBER: 'CS_ONLINE_SET_REQUEST_NUMBER',
  SET_LIST_REQUEST: 'CS_ONLINE_SET_LIST_REQUEST',
  SET_TYPE_CHANGE_INFO: 'CS_ONLINE_SET_TYPE_CHANGE_INFO',
  SET_INFO_HOLDER_BENEFICIARY: 'CS_ONLINE_SET_INFO_HOLDER_BENEFICIARY',
  SET_INFO_HOLDER_BENEFICIARY_AFTER_CHANGED: 'CS_ONLINE_SET_INFO_HOLDER_BENEFICIARY_AFTER_CHANGED',
  SET_INFO_CUSTOMER_CHANGED: 'CS_ONLINE_SET_INFO_CUSTOMER_CHANGED',
  SET_TEMP_INFO_CUSTOMER: 'CS_ONLINE_SET_TEMP_INFO_CUSTOMER',
  SET_INFO_REQUEST_ADDITIONAL: 'CS_ONLINE_SET_INFO_REQUEST_ADDITIONAL',
  SET_INFO_PAYMENT_PERIOD: 'CS_ONLINE_SET_INFO_PAYMENT_PERIOD',
  SET_INFO_PAYMENT_PERIOD_CHANGED: 'CS_ONLINE_SET_INFO_PAYMENT_PERIOD_CHANGED',
  SET_TEMP_INFO_CHANGE_FEE: 'CS_ONLINE_SET_TEMP_INFO_CHANGE_FEE',
  BACK_STEP_INPUT_INFO_TRUE: 'CS_ONLINE_BACK_STEP_INPUT_INFO_TRUE',
  BACK_STEP_INPUT_INFO_FALSE: 'CS_ONLINE_BACK_STEP_INPUT_INFO_FALSE',
  SET_FILE_UPLOAD: 'SET_FILE_UPLOAD',
  LIST_FILE_REGISTER: 'LIST_FILE_REGISTER',
};

export const claimOnline = {
  START_FETCHING: 'CLAIM_START_FETCHING',
  STOP_FETCHING: 'CLAIM_STOP_FETCHING',
  SET_STEP_CREATE: 'CLAIM_SET_STEP_CREATE',
  SET_BENEFIT_SELECTED: 'CLAIM_SET_BENEFIT_SELECTED',
  METHOD_OF_RECEIVING_BENEFITS: 'CLAIM_METHOD_OF_RECEIVING_BENEFITS',
  SET_CONTRACT_SELECTED: 'CLAIM_SET_CONTRACT_SELECTED',
  RESET_STATE: 'CLAIM_RESET_STATE',
  SET_CURRENT_LIFE_INSURED: 'SET_CURRENT_LIFE_INSURED',
  SET_CURRENT_NAME_LIFE_INSURED: 'SET_CURRENT_NAME_LIFE_INSURED',
  SET_LIST_CONTRACT_CLIENT_ID: 'CLAIM_ONLINE/SET_LIST_CONTRACT_CLIENT_ID',
  SET_DATA_API_CREATE_REQUEST: 'SET_DATA_API_CREATE_REQUEST',
  SET_DATA_API_CREATE_ATTACH_FILE: 'SET_DATA_API_CREATE_ATTACH_FILE',
  SET_DATA_API_SEND_OTP: 'SET_DATA_API_SEND_OTP',
  SET_DATA_API_CONFIRM_OTP: 'SET_DATA_API_CONFIRM_OTP',
  SET_DATA_API_SEARCH_REQUEST: 'SET_DATA_API_SEARCH_REQUEST',
  SET_DATA_API_SEARCH_DETAIL_PROFILE: 'SET_DATA_API_SEARCH_DETAIL_PROFILE',
  SET_DATA_API_UPDATE_STATUS: 'SET_DATA_API_UPDATE_STATUS',
  SET_DATA_API_PAYMENT_METHOD: 'SET_DATA_API_PAYMENT_METHOD',
  SET_DATA_API_LIST_HOSPITAL: 'SET_DATA_API_LIST_HOSPITAL',
  SET_DATA_API_LIST_BANK: 'SET_DATA_API_LIST_BANK',
  SET_DATA_API_LIST_COMPANY: 'SET_DATA_API_LIST_COMPANY',
  SET_DATA_MEDICAL_CARE_BENEFITS: 'SET_DATA_MEDICAL_CARE_BENEFITS',
  SET_DATA_CRITICAL_ILLNESS_BENEFITS: 'SET_DATA_CRITICAL_ILLNESS_BENEFITS',
  SET_DATA_DEATH_BENEFIT: 'SET_DATA_DEATH_BENEFIT',
  SET_DATA_DISABILITY_BENEFITS: 'SET_DATA_DISABILITY_BENEFITS',
  SET_LIST_ISSUING_AUTHORITY: 'SET_LIST_ISSUING_AUTHORITY',
  SET_TREATMENT_PLACE_CHANGED: 'SET_TREATMENT_PLACE_CHANGED',
  SET_DATA_UPLOAD_DOCUMENT: 'SET_DATA_UPLOAD_DOCUMENT',
  SET_COMPANY_NAME_CHANGED: 'SET_COMPANY_NAME_CHANGED',
  SET_BANK_NAME_CHANGED: 'SET_BANK_NAME_CHANGED',
  SET_DATA_PAYMENT_CHANGED: 'SET_DATA_PAYMENT_CHANGED',
};

// USER PROFILE
export const USER_PROFILE_CONSTANT = {
  SET_USER_PROFILE: 'SET_USER_PROFILE',
  SET_STATE: 'SET_STATE',
  START_FETCHING: 'START_FETCHING_USER_PROFILE',
  STOP_FETCHING: 'STOP_FETCHING_USER_PROFILE',
  RESET: 'RESET_USER_PROFILE',
};

//NOTIFICATION
export const NOTIFICATION_CONSTANT = {
  START_FETCHING: 'NOTIFICATION_START_FETCHING',
  STOP_FETCHING: 'NOTIFICATION_STOP_FETCHING',
  RESET: 'NOTIFICATION_RESET',
  LOAD_NOTIFICATION: 'LOAD_NOTIFICATION',
  SET_LIST_NOTIFICATION: 'SET_LIST_NOTIFICATION',
  SET_PAGE: 'NOTIFICATION_SET_PAGE',
  SET_PER_PAGE: 'NOTIFICATION_SET_PER_PAGE',
  SET_COUNT_NOTIFY: 'NOTIFICATION_SET_COUNT_NOTIFY',
  SET_COUNT_NOTIFY_NOT_READ: 'NOTIFICATION_SET_COUNT_NOTIFY_NOT_READ',
};

export const COMMON_CONSTANT = {
  SET_NOTICE: 'SET_NOTICE',
  CLOSE_NOTICE: 'CLOSE_NOTICE',
};

export const APP_CONSTANT = {
  SET_SHOW_DRAWER_MENU: 'APP_CONSTANT/SET_SHOW_DRAWER_MENU',
};
